import i18next from 'i18next';

import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';
import type {
    GetAllRuleGroupsQuery,
    GetAllRuleGroupsQueryVariables,
} from 'web-app/react/institution/settings/parent-booking/__generated__/queries.api-types';
import * as Queries from 'web-app/react/institution/settings/parent-booking/queries';

export const useAllRuleGroups = (siteId, supportsRuleGroups) => {
    const [ruleGroupOptions, {loading, refetch}] = useTransformQuery<
        GetAllRuleGroupsQuery,
        GetAllRuleGroupsQueryVariables
    >()(
        Queries.GetAllRuleGroups,
        {
            variables: {
                siteId,
            },
            skip: !supportsRuleGroups,
            fetchPolicy: 'cache-and-network',
        },
        ({data}) => {
            if (data?.institutions?.[0]?.ruleGroups) {
                return data.institutions[0].ruleGroups.map(group => {
                    return {
                        value: group.ruleGroupId,
                        label: group.ruleGroupName ?? i18next.t('settings.parentBookings.ruleGroupLabel'),
                    };
                });
            }

            return [];
        },
    );

    return {ruleGroupOptions, loading, refetch};
};
